var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comments',{attrs:{"boardId":_vm.board,"articleId":_vm.id,"category":_vm.category,"uid":_vm.uid}})}
var staticRenderFns = []

export { render, staticRenderFns }